import { AxiosInstance, AxiosResponse } from 'axios'

import { UserApiDocumentClientRepository } from './domain/UserApiDocument'

import {
  CommunityCategory,
  CommunityDocument,
  PostCommunityDocumentParam,
  PostCommunityDocumentResponse,
} from '../../contracts/community'
import { SortTypes } from '../../contracts/search'
import { SolarPagedResponse } from '../../foundation'

export interface CommunityDocumentQuery {
  start?: number
  length?: number
  sort?: SortTypes
  isBest?: boolean
  hasComments?: boolean
  writtenByDoctor?: boolean
  categoryId?: number
  categoryIds?: string
  languages?: string
}

export class UserApiDocument implements UserApiDocumentClientRepository {
  private axios: AxiosInstance

  constructor({ axios }: { axios: AxiosInstance }) {
    this.axios = axios
  }

  postDocument(payload: PostCommunityDocumentParam): Promise<AxiosResponse<PostCommunityDocumentResponse>> {
    return this.axios.request({
      url: '/document',
      method: 'post',
      params: payload,
    })
  }

  getDocuments(queries: CommunityDocumentQuery) {
    return this.axios.request<SolarPagedResponse<CommunityDocument[]>>({
      url: '/document',
      method: 'get',
      params: queries,
    })
  }

  getDocumentCategories(payload: {
    memberType: 'MEMBER' | 'ADMIN'
    permission: 'READ' | 'WRITE'
  }): Promise<AxiosResponse<{ communityCategories: CommunityCategory[] }>> {
    return this.axios.request({
      url: '/community/queries/community-categories/process',
      method: 'post',
      data: payload,
    })
  }

  thumbUp(documentId: number, memberId: number) {
    return this.axios.request({
      url: `/document/${documentId}/thumbUp`,
      method: 'post',
      params: {
        memberId,
      },
    })
  }

  cancelThumbUp(documentId: number, memberId: number) {
    return this.axios.request({
      url: `/document/${documentId}/thumbUp`,
      method: 'delete',
      params: {
        memberId,
      },
    })
  }
}
